export default __webpack_public_path__ + "static/partner_dynamicyield_stacked-685529613f763a6a13404b1c0c8c86c8.png";